
const convertToExpressionValue = (value) => {
  let transformedValue = value;
  if (typeof value === 'object') {
    try {
      transformedValue = JSON.stringify(value);
    } catch (error) {
      // We'll just return [object Object] in this case.
    }
  }
  return transformedValue;
};

const standardResponseTransformer = (response) => {
  const { rows, ...meta } = response;
  let columns = [];
  let values = [];

  if (rows) {
    // First get all the columns from all rows
    columns = rows.reduce(
      (returnObject, row) => {
        const columnsForRow = Object.keys(row)
        // Filter out _hits, as we'll deal with it separately
          .filter(columnName => (columnName !== '_hits'));

        if (row._hits) columnsForRow.push('_hits', '_topHit');

        return columnsForRow;
      },
      [],
    );
    // Then make it unique
    columns = Array.from(
      new Set([
        ...columns,
      ]),
    );

    values = rows.map((row) => {
      let hits = '';
      let topHit = '';
      if (row._hits) {
        // If we have _hits, attempt to calculate hits
        try {
          hits = JSON.parse(row._hits);
          const first = hits[0];
          topHit = (
            first &&
            first.fieldValues &&
            first.fieldValues.turns &&
            first.fieldValues.turns.text
          ) || [];
        } catch (error) {
          // We can't determine the hits properly, leave them out for this row.
        }
      }

      return columns.map((columnName) => {
        if (columnName === '_hits') return convertToExpressionValue(hits);
        if (columnName === '_topHit') return convertToExpressionValue(topHit);
        return row[columnName] !== undefined && row[columnName] !== null ? convertToExpressionValue(row[columnName]) : 'NULL';
      });
    });
  }

  return {
    columns,
    values,
    meta,
  };
};

const transformResults = (response) => {
  const results = standardResponseTransformer(response);
  const data = results.values
    .map(row => row.reduce((acc, value, i) => Object.assign(acc, { [results.columns[i]]: value }), {}))
  ;

  return {
    data,
    columns: results.columns,
    meta: results.meta,
  };
};

export default transformResults;
